import { Parser } from 'expr-eval-fork';
import { useCallback, useState } from 'react';
import { useFormContext, useFormState } from 'react-hook-form';
import { components } from '@types';

interface IUseRequirementsModalProps {
  disabled: boolean;
  missing_fields: string[];
  requirements: components['schemas']['RequirementResponse'][];
  disable_if?: string;
  onOpen?: () => void;
}

export const useRequirementsModal = ({
  disable_if,
  disabled,
  onOpen,
  requirements,
  missing_fields,
}: IUseRequirementsModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { watch, control } = useFormContext();
  const { errors } = useFormState({ control });

  const formIsInvalid =
    missing_fields.some(item =>
      requirements.some(req => req.field_name === item),
    ) || requirements.some(req => Object.keys(errors).includes(req.field_name));

  const handleOpen = useCallback(() => {
    setIsOpen(true);
    if (onOpen) {
      onOpen();
    }
  }, [onOpen]);

  const handleClose = () => setIsOpen(false);

  const formValues = watch();

  let isDisabled = disabled;

  if (disable_if) {
    const parser = new Parser();
    const expr = parser.parse(disable_if);
    const exprEvalResult = expr.evaluate(formValues);

    if (exprEvalResult) {
      isDisabled = true;
    }
  }

  return {
    isOpen,
    handleOpen,
    handleClose,
    isDisabled,
    formIsInvalid,
  };
};
